module.exports = __webpack_public_path__ + "img/hand.7c5be22a.png";